import React from "react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { convertToBrazilDate } from "../../../helpers/date";
import { PostContentText } from "./PostContentText";
import { TagList } from "./TagList";

const PostDate = ({ date }) => (
  <div className="flex flex-row gap-1 mb-2 min-h-8">
    <div className="flex items-end gap-1">
      <CalendarIcon className="size-5 text-gray-400" />
      <span className="text-gray-400 font-bold text-sm">
        {convertToBrazilDate(date)}
      </span>
    </div>
  </div>
);

export function PostCard({
  post: { id, title, content, published_at, tags },
  full = false,
  showBorder = true,
  compact = false,
  alwaysClickable = false,
  titleClickable = false,
}) {
  const cardUrl = `/blog/post/${id}`;

  const containerClass = full ? "" : "xl:w-[30%]";
  const borderClasses = showBorder
    ? "border-2 border-transparent hover:border-brandpink hover:border-2"
    : "";
  const contentTextClasses = compact
    ? "overflow-hidden overflow-ellipsis bg-deep-space text-white line-clamp-2 transition-colors duration-300"
    : undefined;

  const titleHeightClass = compact ? "min-h-8" : "h-auto min-h-12 max-h-24 py-2 sm:py-0 xl:py-2";

  return (
    <div className={`relative w-full ${containerClass}`}>
      <div
        className={`group h-full p-4 rounded-lg ${borderClasses} bg-deep-space transition ease-in duration-300`}
      >
        <a
          href={cardUrl}
          className={`absolute inset-0 z-10 ${alwaysClickable ? "" : "lg:hidden"}`}
          aria-label={`Ler mais sobre ${title}`}
        />

        <h2
          className={`${titleHeightClass} flex items-center justify-center text-center text-xl font-bold mb-4 text-white group-hover:text-brandpink uppercase overflow-hidden line-clamp-3`}
        >
          {titleClickable ? (
            <a
              href={cardUrl}
              className="relative z-20 hover:text-brandpink line-clamp-3 w-full"
              aria-label={`Ler mais sobre ${title}`}
            >
              {title}
            </a>
          ) : (
            title
          )}
        </h2>
        <PostDate date={published_at} />
        {compact && (
          <div className="mb-2">
            <TagList tags={tags} iconPosition="left" />
          </div>
        )}
        <PostContentText content={content} className={contentTextClasses} />

        {!compact && (
          <div className="flex flex-col items-start mt-4 mb-2 min-h-6 gap-2">
            <a
              href={cardUrl}
              className="relative z-20 group inline-flex items-center justify-center gap-1 text-sm font-bold text-white px-4 py-2 rounded-md bg-brandpink hover:bg-brandpink-darker transition ease-in duration-300 w-full"
            >
              Ler mais
            </a>
            <TagList tags={tags} iconPosition="left" />
          </div>
        )}
      </div>
    </div>
  );
}
